import { get, post, put, remove } from "../../api_helper";
import * as url from "../../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const createVendorLog = (payload) => post(baseURL + url.VENDOR_LOG, payload);
export const getVendorLogDetails = (id) => get(`${baseURL + url.VENDOR_LOG}/${id}`);
export const updateVendorLog = (id, payload) => put(`${baseURL + url.VENDOR_LOG}/${id}`, payload);
export const deleteVendorLog = (id) => remove(`${baseURL + url.VENDOR_LOG}/${id}`);